import Component from './component';
import { makeDefault } from './defaults';
import { isValidData } from './validator';

export const Emoji = { Component, makeDefault, isValidData } as const;
export type { EmojiData } from './types';
